import apiService from "./ApiService"
import { createQS } from "./Utils"

class ConsorcioService {
  async get(termo, pagina) {
    try {
      const qs = createQS({ termo, pagina })
      return await apiService.get('consorcio?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('consorcio/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('consorcio', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('consorcio/' + id, data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('consorcio/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getEmpresas(idConsorcio) {
    try {
      return await apiService.get('consorcio/' + idConsorcio + '/empresa')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async createEmpresa(idConsorcio, data) {
    try {
      return await apiService.post('consorcio/' + idConsorcio + '/empresa', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async updateEmpresa(idConsorcio, idEmpresa, data) {
    try {
      return await apiService.put('consorcio/' + idConsorcio + '/empresa/' + idEmpresa, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async updateEmpresaLider(idConsorcio, idEmpresa) {
    try {
      return await apiService.put('consorcio/' + idConsorcio + '/empresa/' + idEmpresa + '/tornar_lider')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deleteEmpresa(idConsorcio, idEmpresa){
    try {
      return await apiService.delete('consorcio/' + idConsorcio + '/empresa/' + idEmpresa)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getEmpresas(idConsorcio) {
    try {
      return await apiService.get('consorcio/' + idConsorcio + '/empresa')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getResponsavelTecnico(idConsorcio) {
    try {
      return await apiService.get('consorcio/' + idConsorcio + '/responsavel_tecnico')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getPreposto(idConsorcio){
    try {
      return await apiService.get('consorcio/' + idConsorcio + '/preposto')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const consorcioService = new ConsorcioService()
export default consorcioService